// ** React Imports
import { lazy } from 'react';

const MedicalServiceRoutes = [
  {
    path: 'medical-services',
    component: lazy(() => import('pages/medical-services')),
  },
];

export default MedicalServiceRoutes;
